<template>
  <section class="detail-page-container">
    <div class="top-bar">
      <div class="inline"></div>
      <span>Policy</span>
    </div>
    <div class="main-header">
      <div
        class="flex-sb type-margin">
        <div class="">
          <div class="header-title flex">
            <span
              class="icon"
              :class="{
                'gray': detailData.effectiveness == 1,
                'green': detailData.effectiveness == 2,
                'red': detailData.effectiveness == 3
              }">
              <font-awesome-icon icon="file-powerpoint" />
            </span>
            <h3>{{ detailData.class_language }}</h3>
            <div
              v-if="detailData.pcy_no"
              class="flex flex-num">
              <span class="num-text">Policy</span>
              <span
                class="span-num">{{detailData.pcy_no}}</span>
            </div>
            <div>
              <span
                v-if="detailData.order_sn"
                class="num-text">Ref <span class="span-num">{{ detailData.order_sn }}</span></span>
            </div>
          </div>

          <div class="flex flex-inline">
            <span
              class="span-status"
              :class="{
                'orange': [401, 301].includes(detailData.pcy_stts),
                'yellow-dark': detailData.pcy_stts == 410,
                'blue': [420, 505, 705].includes(detailData.pcy_stts),
                'green': [425, 501, 510, 701].includes(detailData.pcy_stts),
                'red': [801, 0].includes(detailData.pcy_stts),
                'purple': [710].includes(detailData.pcy_stts),
              }">
              <font-awesome-icon
                v-if="[425, 510].includes(detailData.pcy_stts)"
                icon="clipboard-check" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 401"
                icon="pen-nib" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 410"
                icon="check" />
              <font-awesome-icon
                v-if="[420, 505, 705].includes(detailData.pcy_stts)"
                icon="print" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 801"
                icon="hourglass-end" />
              <font-awesome-icon
                v-if="[301, 501, 701].includes(detailData.pcy_stts)"
                icon="file-invoice-dollar" />
              <font-awesome-icon
                v-if="detailData.pcy_stts == 0"
                icon="skull" />
              <font-awesome-icon
                v-if="[710].includes(detailData.pcy_stts)"
                icon="calendar-check" />
              {{ detailData.pcy_stts_language }}
            </span>
            <span
              v-for="(v,i) in detailData.tag_language"
              :key="i"
              class="span-options"
              :class="{
                'gold': v.id == 1,
                'blue': v.id == 2,
                'orange': v.id == 4,
                'black': [8,16].includes(v.id)
              }"
            >{{v.name}}</span>
            <span class="header-date">Issued On</span>
            <span class="number-color number-fontsize">{{ detailData.issue_dt }}</span>
            <span class="header-date">Updated</span>
            <span class="number-color number-fontsize">{{ detailData.updated_at }}</span>

          </div>
        </div>
        <div class="form-item">
          <span>Assignee</span>
          <span>

            <v-select
              v-model="detailData.cs_id"
              icon="user-nurse"
              :list="globalOptions.assignee"
              @change="selectAssignee"
            />
          </span>
        </div>
      </div>
      <div >
        <div  v-if="!showOther">
          <el-tabs
            v-model="activeTab"
            @tab-click="handleChangeLog">
            <el-tab-pane
              v-for="(tab, index) in tabList"
              :key="index"
              :label="tab.label"
              :name="String(tab.name)"
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <!--      <div class="top">-->
      <!--        <div class="company-logo">-->
      <!--          <img-->
      <!--            :src="getOptionData('companys', detailData.company_id).logo? getOptionData('companys', detailData.company_id).logo: detailData.company_logo"-->
      <!--            alt="logo" />-->
      <!--        </div>-->
      <!--        <h1 class="title-h1">{{ detailData.class_language }}</h1>-->
      <!--      </div>-->
      <!--      <div class="info-container">-->
      <!--        <div>-->
      <!--          <span>Insurance Type</span>-->
      <!--          <span>-->

      <!--            {{ detailData.class_language }}-->
      <!--          </span>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <span>Policy No.</span>-->
      <!--          <span>{{ detailData.pcy_no }}</span>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <span>Issued On</span>-->
      <!--          <span>-->
      <!--            {{ detailData.issue_dt }}-->
      <!--          </span>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <span>Last Updated</span>-->
      <!--          <span>-->
      <!--            {{ detailData.updated_at }}-->
      <!--          </span>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <span>Status</span>-->
      <!--          <span class="span-checkbox success">-->
      <!--            {{ detailData.pcy_stts_language }}-->
      <!--            &lt;!&ndash; {{ getGlobalOptionName('policy_status', detailData.stts) || detailData.stts }} &ndash;&gt;-->
      <!--          </span>-->
      <!--        </div>-->
      <!--        <div class="form-item">-->
      <!--          <span>Assignee</span>-->
      <!--          <span>-->

      <!--            <v-select-->
      <!--              v-model="detailData.cs_id"-->
      <!--              icon="user-nurse"-->
      <!--              :list="globalOptions.assignee"-->
      <!--              @change="selectAssignee"-->
      <!--            />-->
      <!--          </span>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <section class="main-container">

      <div class="main-body">
        <template v-if="showOther">
          <business-payment
            type="addRecord"
            :orderId="orderId"
            :customer="detailData.customer"
            :customerId="detailData.customer_id"
            @cancel="handlerBusinessPaymentCancel"
            @business-payment-success="handlerBusinessPaymentSuccess" />
        </template>
        <template v-else>
          <section class="main-content">
            <div
              v-if="showStatusBar"
              class="status-bar flex-sb">
              <div class="left">
                <span>Endorsement Quote</span>
                <span>This policy has an endorsement quote pending.</span>
              </div>
              <div class="right">
                <v-button @click="viewTicket">View Support Ticket</v-button>
              </div>
            </div>

            <!--            <el-tabs v-model="activeTab">-->
            <!--              <el-tab-pane-->
            <!--                v-for="(tab, index) in tabList"-->
            <!--                :key="index"-->
            <!--                :label="tab.label"-->
            <!--                :name="String(tab.name)"-->
            <!--              ></el-tab-pane>-->
            <!--            </el-tabs>-->
            <policy-tab
              v-show="activeTab == 'Policy'"
              :activeTab="activeTab"
              :form="detailData"
              :orderId="orderId"
              @update="handler().getUpdateData()" />
            <document-form
              v-show="activeTab == 'Documents'"
              :list="detailData.internal_doc"
              :order_id="Number(orderId)"
              @updateDetail="handler().getUpdateData()"/>
            <payment-record
              v-show="activeTab == 'Payment'"
              :isManual="true"
              :records="detailData.payment_record"
              :class_id = "detailData.class_id"
              @refresh="refresh"
              @add-record="handlerAddPaymentRecord"
            />
            <policy-invoice
              v-show="activeTab == 'Invoice'"
              :stts="detailData.pcy_stts"
              :isManual="true"
              :orderId="orderId"
              :invoice="detailData.policy_invoice"
              @update="handler().getUpdateData()" />
            <tickets-tab
              v-show="activeTab == 'Tickets'"
              :form="detailData"
              @update-data="updateTicketsData" />
            <claims-tab
              v-show="activeTab == 'Claims'"
              :isManual="true"
              :claims="detailData.claims_record"
              @add-claim="handlerAddClaim" />
            <the-cheques
              v-show="activeTab == 'Cheques'"
              :cheques="detailData.cheques"
              @update="handler().getUpdateData()"
            />
            <detail-log
              v-show="activeTab == 'log'"
              :logsData="logsData">
            </detail-log>
          </section>

          <aside>
            <div
              v-if="detailData.referrer_dollars_send==0&&showDollars"
              class="card status-bar-blue">
              <div >
                <span class="title">Add Hold Dollars To Referrer</span>
                <span class="text">This policy is ready to give Hold Dollars to referrer.</span>
              </div>
              <div>
                <v-button
                  icon="user-lock"
                  class="btn-text"
                  @click="handlerOpenDollars">Add Hold Dollars</v-button>
              </div>
            </div>
            <div
              v-if="showDeleteBtn"
              class="card status-bar-yellow">
              <div >
                <span class="title">Turn To New Policy</span>
                <span class="text">Complete this policy once it is issued by the insurer.</span>
              </div>
              <div>
                <v-button
                  class="btn-text"
                  icon="clipboard-check"
                  @click="handlerEnterPolicy">Enter Policy No.</v-button>
              </div>
            </div>
            <div class="card child-button-block">
              <span class="label">Actions</span>
              <v-button
                type="primary"
                icon="plus"
                @click="openDialog('new-general-ticket')">New General Ticket</v-button>
              <v-button
                type="warning"
                icon="plus"
                @click="openDialog('create-cheque')">Create Cheque</v-button>
              <v-button
                v-show="showDeleteBtn"
                type="danger"
                icon="trash-alt"
                @click="handlerDeletePolicy">Delete Policy</v-button>
            </div>
            <div class="card">
              <span class="label">Customer Profile</span>
              <span class="name">{{ detailData.customer.isrd_nm }}</span>
              <div class="table">
                <div class="tr">
                  <span>Joined</span>
                  <span>{{ detailData.customer.created_at }}</span>
                </div>
                <div class="tr">
                  <span>Policies</span>
                  <span>{{ detailData.customer.polices }} Active</span>
                </div>
              </div>
              <v-button
                type="primary"
                @click="viewCustomer">View Customer</v-button>
            </div>
            <div
              class="card">
              <div class="flex-sb-center share-content">
                <span class="label">Sharing With</span>
                <span
                  v-if="shareInfo.id"
                  class="blue hand"
                  @click="handleUnShare">Don't Share</span>
              </div>
              <template v-if="shareInfo.id">
                <div
                  class="flex flex-wrap text-decoration-none">
                  <span
                    class="name hand"
                    @click="viewShareCustomer"
                  >{{ shareInfo.isrd_nm }} &nbsp;</span>
                </div>

                <div class="table">
                  <div class="tr">
                    <span>Joined</span>
                    <span>{{ shareInfo.created_date || '-' }}</span>
                  </div>
                  <div class="tr">
                    <span>Policy Count</span>
                    <span>{{ shareInfo.policys || 0 }}</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <v-button
                  plain
                  icon="user-friends"
                  @click="handlerShare">Share with Another User</v-button>
              </template>
            </div>
            <div class="card">
              <span class="title">Internal Remarks</span>
              <div class="remarks-container">
                <div
                  v-for="(item, index) in remarkList"
                  :key="index"
                  class="remark-box">
                  <div class="remark-header">
                    <span>{{ item.cs_name }}</span>
                    <span>{{ item.created_at }}</span>
                  </div>
                  <p>{{ item.message }}</p>
                </div>
              </div>
              <div class="remark-add">
                <v-input
                  v-model="message"
                  class="mg-b-15"
                  @keyEnter="handlerAddRemark" />
                <v-button
                  size="small"
                  type="primary"
                  @click="handlerAddRemark">Add Remark</v-button>
              </div>
            </div>
          </aside>
        </template>
      </div>
    </section>
    <!-- dialog -->
    <new-general-ticket
      ref="new-general-ticket"
      :form="ticketParams" />
    <new-endorsement-ticket
      ref="new-endorsement-ticket"
      :orderId="orderId"
      :form="ticketParams" />

    <new-claim-ticket
      ref="new-claim-ticket"
      :orderId="orderId"
      :form="ticketParams"
      :customer="detailData.customer"
      :continute="false"
      @success="handler().getUpdateData()"
    />

    <create-cheque
      ref="create-cheque"
      :form="chequeParams"
      @done="network().updatePolicyDetail()" />
    <set-void-quote
      ref="void-dialog"
      :orderId="orderId"
      @setVoid="handlerVoidDone"
    >
    </set-void-quote>
    <add-dollar-dialog
      ref="add-dollar-dialog"
      :customer_id="detailData.customer_id"
      :customer="detailData.customer"
      :form="detailData"
      @setVoid="handlerAddDollars"
    >
    </add-dollar-dialog>
    <enter-policy-no-dialog
      ref="enter-policy-no-dialog"
      :orderId="orderId"
      :form="detailData"
      @setVoid="handlerEnterNo"
    >
    </enter-policy-no-dialog>
    <attach-user
      ref="attach-user"
      :is-share="true"
      @shareUser="handleShareCustomerId"
    />
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import PolicyTab from './components/manual/policy-tab'
import DocumentForm from '@/views/components/internal-document'
import PaymentRecord from './components/payment-record'
import TicketsTab from './components/tickets-tab'
import TheCheques from './components/cheques'
import ClaimsTab from './components/claims-tab'
import PolicyInvoice from './components/policy-invoice'
import NewGeneralTicket from '@/views/tickets/dialogs/new-general-ticket'
import NewEndorsementTicket from '@/views/tickets/dialogs/new-endorsement-ticket'
import NewClaimTicket from '@/views/tickets/dialogs/new-claim-ticket'
import {
  addHoldDollars,
  addPolicyRemark,
  enterManualPolicyNo,
  getManualPolicyDetail,
  getPolicyDetailLog
} from '@/api/policy'
import CreateCheque from './components/dialog/create-cheque'
import BusinessPayment from '@/views/tickets/components/business-payment'
import {orderCsSet} from '@api/quote'
import setVoidQuote from '@/views/components/set-void-quote'
import AddDollarDialog from '@/views/components/add-holder-dollar-dialog'
import enterPolicyNoDialog from '@/views/components/enterPolicyNoDialog'
import detailLog from '@/views/components/log/detail-log'
import AttachUser from '@/views/quoting/dialogs/attachCustomer'
import {removeShareUserPolicy, shareUserPolicy} from '@/api/share'

export default {
  name: 'ManualPolicyDetail',
  components: {
    PolicyTab,
    PaymentRecord,
    TicketsTab,
    TheCheques,
    ClaimsTab,
    PolicyInvoice,
    NewGeneralTicket,
    NewEndorsementTicket,
    NewClaimTicket,
    DocumentForm,
    CreateCheque,
    BusinessPayment,
    setVoidQuote,
    AddDollarDialog,
    enterPolicyNoDialog,
    detailLog,
    AttachUser
  },
  mixins: [MixinOptions],
  data() {
    return {
      showOther: false,
      activeTab: 'Policy',
      tabList: [
        {
          name: 'Policy',
          label: 'Policy'
        },
        {
          name: 'Documents',
          label: 'Internal Documents'
        },
        {
          name: 'Payment',
          label: 'Payment Record'
        },
        {
          name: 'Invoice',
          label: 'Policy & Invoice'
        },
        {
          name: 'Tickets',
          label: 'Tickets'
        },
        {
          name: 'Claims',
          label: 'Claims'
        },
        {
          name: 'Cheques',
          label: 'Cheques'
        },
        {
          name: 'log',
          label: 'Log'
        },
      ],
      detailData: {
        customer: {}
      },
      // assignee: '',
      remarkList: [],
      message: '',
      orignal_cs:'',
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      logsData:[]
    }
  },
  computed: {
    productId() {
      return this.$route.query.product_id || 11
    },
    orderId() {
      return this.$route.query.id
    },
    showStatusBar() {
      const { endorsement_quote_pending } = this.detailData
      if(!endorsement_quote_pending || !endorsement_quote_pending.id) {
        return false
      }
      return true
    },
    ticketParams() {
      const { cs_id, customer_id, pcy_no, quotation_number, pcy_id } = this.detailData
      return {
        assignee_id: cs_id,
        customer_id,
        policy_no: pcy_no,
        quote_no: quotation_number,
        pcy_id
      }
    },
    chequeParams() {
      const { customer, id, customer_id } = this.detailData
      return {
        isrd_nm: customer? customer.isrd_nm : '',
        order_id: this.$route.query.id,
        customer_id
      }
    },
    showDeleteBtn(){
      let {pcy_stts} = this.detailData
      return pcy_stts==420
    },
    showDollars(){
      let {pcy_stts,code} = this.detailData
      return pcy_stts==425&&code
    },
    shareInfo(){
      let {share_user_infos} = this.detailData
      return share_user_infos||{}
    },
    pcyId() {
      return this.$route.query.pcy_id
    },
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getManualPolicyDetail()
        if(this.$route.query.tab) {
          this.activeTab = this.$route.query.tab
        }
      }
    }
  },
  methods: {
    handleChangeLog(){
      if(this.activeTab=='log')
        this.network().getPolicyDetailLog()
    },
    selectAssignee(id) {
      orderCsSet({
        order_id: this.orderId,
        cs_id: id,
      }).then(data=>{
        this.orignal_cs = id
        this.$message({
          type: 'success',
          message: 'Success'
        })
      }).catch(err=>{
        this.detailData.cs_id = this.orignal_cs
      })
    },
    viewCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.detailData.customer_id
        }
      })
    },
    viewTicket() {
      const { id } = this.detailData.endorsement_quote_pending
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: id
        }
      })
    },
    handlerEnterPolicy(){
      this.$refs['enter-policy-no-dialog'].changeDialog()
    },
    handlerOpenDollars(){
      this.$refs['add-dollar-dialog'].changeDialog()
    },
    updateTicketsData(data) {
      this.network().getManualPolicyDetail(data)
    },
    handlerAddClaim() {
      this.openDialog('new-claim-ticket')
    },
    handlerAddRemark() {
      if(this.message) {
        this.network().addPolicyRemark()
      }
    },
    openDialog(target) {
      if(target) {
        this.$refs[target].changeDialog()
      }
    },
    handlerDeletePolicy() {
      this.$refs['void-dialog'].changeDialog()
    },
    refresh(){
      this.network().getManualPolicyDetail()
    },
    handlerAddPaymentRecord() {
      this.showOther = true
    },
    handlerBusinessPaymentCancel() {
      this.showOther = false
    },
    handlerBusinessPaymentSuccess() {
      this.showOther = false
      this.handler().getUpdateData()
    },
    handler() {
      return {
        getUpdateData: () => {
          this.network().getManualPolicyDetail()
        }
      }
    },
    handlerVoidDone(data) {
      const { order_id, pcy_id } = data
      this.$router.replace({
        path: '/records/policy/manual/detail',
        query: {
          id: order_id,
          pcy_id,
          product_id: this.productId
        }
      })
      this.network().getManualPolicyDetail()
    },
    handlerEnterNo(data){
      let params = {
        pcy_no:data
      }
      this.network().enterManualPolicyNo(params)
    },
    handlerAddDollars(data){
      let params = {
        hd_dollars:data
      }
      if(data)
        this.network().addHoldDollars(params)
    },
    handleUnShare(){
      this.$ConfirmBox({
        message: 'Confirm don\'t share ?',
        cancelBtn:'No',
      }).then(() => {
        this.network().removeShareUserPolicy()
      })
    },
    handlerShare(){
      this.$refs['attach-user'].showAttachCustomer()
    },
    viewShareCustomer() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.shareInfo.id
        }
      })
    },
    handleShareCustomerId(data){
      this.network().shareUserPolicy({share_user_id:data})
    },
    network() {
      return {
        setTicketCs: async params => {
          const {data} = await orderCsSet({
            order_id: this.orderId,
            ...params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        enterManualPolicyNo: async (params = {}) => {
          const { data } = await enterManualPolicyNo({
            order_id: this.orderId,
            ...params
          })
          this.network().getManualPolicyDetail()
        },
        addHoldDollars: async (params = {}) => {
          const { data } = await addHoldDollars({
            order_id: this.orderId,
            ...params
          })
          this.network().getManualPolicyDetail()
        },
        getManualPolicyDetail: async (params = {}) => {
          const { data } = await getManualPolicyDetail({
            order_id: this.orderId,
            ...params
          })
          this.detailData = data
          this.orignal_cs = data.cs_id
          // this.assignee = data.assignee
          if(data.remark_list) {
            this.remarkList = JSON.parse(JSON.stringify(data.remark_list))
          }
        },
        addPolicyRemark: async () => {
          const { data } = await addPolicyRemark({
            pcy_id: this.detailData.pcy_id,
            message: this.message
          })
          this.message = ''
          // todo 追加 remark
          this.remarkList.unshift(data)
        },
        updatePolicyDetail: () => {
          this.network().getProductData({
            hideLoading: true
          })
          // if(this.productId == 12) {
          //   this.network().getHousemaidPolicyDetail({
          //     hideLoading: true
          //   })
          //   return
          // }
          // this.network().getPolicyDetail({
          //   hideLoading: true
          // })
        },
        getProductData: (params = {}) => {
          this.network().getManualPolicyDetail()
          switch(Number(this.productId)) {
            case 11:
              this.network().getPolicyDetail(params)
              break
            case 12:
              this.network().getHousemaidPolicyDetail(params)
              break
            case 15:
              this.network().getInteriorPolicyDetail(params)
              break
            case 17:
              this.network().getHomefirePolicyDetail(params)
              break
          }
        },
        getPolicyDetailLog: async () => {
          const {data} = await getPolicyDetailLog({
            pcy_id:this.detailData.pcy_id,
            page: this.pageConfig.currentPage,
          })
          this.logsData = data.data
        },
        shareUserPolicy: async (params) => {
          const {data} = await shareUserPolicy({
            pcy_id:this.pcyId,
            ...params
          })
          this.network().updatePolicyDetail()
          this.handleChangeLog()
        },
        removeShareUserPolicy: async () => {
          const {data} = await removeShareUserPolicy({
            pcy_id:this.pcyId,
          })
          this.network().updatePolicyDetail()
          this.handleChangeLog()
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
//@import '../../../assets/css/pay-main-header';
::v-deep .el-main{
  background: #fff!important;
}
.detail-page-container {
  position: relative;
  background: #fff;
  margin: -20px;
  .top-bar {
    color: #409eff;
    font-size: 13px;
    padding-top: 30px;
    margin-left:70px ;
    font-weight: bold;
    background: #fff!important;
    .inline{
      height: 1px;
      background: #409eff;
    }
  }

  .status-bar-blue{
    box-sizing: border-box;
    //height: 145px;
    width: 250px;
    border: 1px solid rgba(4,66,137,0.2);
    border-radius: 4px;
    background-color: #DBEDFF;
    padding: 18px;
    .title{
      height: 17px;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 17px;
    }
    .text{
      //height: 34px;
      width: 218px;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
      margin-top: 10px;
      display: block;
    }
    .btn-text{
      height: 20px;
      margin-top: 20px;
      color: #FFFFFF;
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 20px;
      box-sizing: border-box;
      height: 32px;
      width: 218px;
      border: 1px solid rgba(27,31,35,0.15);
      border-radius: 6px;
      background-color: #2EA44F;
      box-shadow: inset 0 1px 0 0 rgba(255,255,255,0.03), 0 1px 0 0 rgba(27,31,35,0.1);
    }
  }
  .status-bar-yellow{
    box-sizing: border-box;
    //height: 145px;
    width: 250px;
    border: 1px solid rgba(176,136,0,0.2);
    border-radius: 4px;
    background-color: #FFFBDD;
    padding: 18px;
    .title{
      height: 17px;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 17px;
    }
    .text{
      height: 34px;
      width: 218px;
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
      margin-top: 10px;
      display: block;
    }
    .btn-text{
      height: 20px;
      margin-top: 20px;
      color: #FFFFFF;
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 20px;
      box-sizing: border-box;
      height: 32px;
      width: 218px;
      border: 1px solid rgba(27,31,35,0.15);
      border-radius: 6px;
      background-color: #2EA44F;
      box-shadow: inset 0 1px 0 0 rgba(255,255,255,0.03), 0 1px 0 0 rgba(27,31,35,0.1);
    }
  }
  .main-header{
    padding: 20px 70px 0px 70px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FFF!important;
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    ::v-deep .el-tabs--top{
      margin-top: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
    .type-margin{
      margin-bottom: 20px;
    }
    .ticket-number{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #24292E;
      height: 20px;
    }
    .header-title{
      display: flex;
      align-items: center;
      .icon {
        font-size: 18px;
        &.gray {
          color: #586069;
        }
        &.green {
          color: #22863A;
        }
        &.red {
          color: #D73A49;
        }
      }
      h3{
        height: 24px;
        color: #24292E;
        font-family: Inter;
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 0!important;
        padding: 0 15px;
      }
      .flex-num{
        margin-left: 20px;
      }
      .num-text{
        color: #586069;
        font-family: Inter;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 20px;
        margin-right: 10px;
      }
      .span-num{
        color: #24292E;
        font-family: Inter;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        padding-right: 20px;
      }
    }
    .span-status, .span-options {
      display: inline-block;
      margin-right: 15px;
      padding: 5px 10px;
      border-radius: 12px;
      font-size: 12px;
      line-height: 14px;
      color: white;
      font-weight: 500;
      .svg-inline--fa {
        margin-right: 5px;
        font-size: 14px;
      }
    }
    .span-status {
      &.green {
        background: #28a745;
        color: white;
      }
      &.orange {
        background: #E36209;
        color: white;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.red {
        background: #d73a49;
      }
      &.min-green {
        background: #dcffe4;
        color: #28a745;
      }
    }
    .span-options {
      border: 1px solid;
      &.gray {
        border-color: #586069;
        color: #586069;
      }
      &.green {
        border-color: #22863A;
        color: #22863A;
      }
      &.red {
        border-color: #D73A49;
        color: #D73A49;
      }
      &.gold {
        border-color: #735C0F;
        color: #735C0F;
      }
      &.blue {
        border-color: #0366D6;
        color: #0366D6;
      }
      &.orange {
        border-color: #C24E00;
        color: #C24E00;
      }
      &.black {
        border-color: #24292E;
        color: #24292E;
      }
    }
    .flex-inline{
      align-items: center;
      margin-top: 20px;
    }
    .header-date{
      //height: 20px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      //line-height: 20px;
      color: #586069;
      margin-right: 0;
    }
    .number-fontsize{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      //line-height: 20px;
      display: flex;
      align-items: center;
      color: #24292E;
      margin-left: 8px;
      margin-right: 15px;
    }
  }
  .main-container {
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    //.main-header {
    //  .top {
    //    display: flex;
    //    align-items: center;
    //    padding-bottom: 15px;
    //    h1 {
    //      padding-bottom: 0;
    //    }
    //    .company-logo {
    //      margin-right: 15px;
    //      height: 42px;
    //      img {
    //        height: 42px;
    //      }
    //    }
    //  }
    //  .info-container {
    //    display: flex;
    //    justify-content: space-between;
    //    margin: 0 -15px;
    //    padding: 15px 15px 0 15px;
    //    border-top: 1px solid #dddfe7;
    //    & > div {
    //      font-size: 14px;
    //      color: #91939a;
    //      & > span:first-child {
    //        display: block;
    //        padding-bottom: 5px;
    //        font-size: 14px;
    //        font-weight: bold;
    //        color: #616266;
    //      }
    //    }
    //  }
    //}
    .main-body {
      display: flex;
      width: 100%;
      .main-content {
        flex: 1;
        margin-right: 15px;
        .status-bar {
          padding: 15px;
          align-items: center;
          background: #E6A23D;
          border-radius: 4px;
          .left {
            color: white;
            span {
              display: block;
              font-size: 14px;
              &:first-child {
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }
      }
      aside {
        width: 250px;
        // min-width: 250px;
        // max-width: 250px;
        .remark-add {
          z-index: 2;
          margin: 0 -15px;
          padding: 15px 15px 0 15px;
          border-top: 1px solid #dddfe7;
        }
        .remarks-container {
          z-index: 1;
          max-height: 300px;
          overflow-y: auto;
          .remark-box {
            margin-bottom: 10px;
            font-size: 12px;
            color: #91939a;
            .remark-header {
              display: flex;
              justify-content: space-between;
              span:first-child {
                font-weight: bold;
              }
            }
            p {
              padding-bottom: 10px;
              color: #616266;
            }
          }
        }
      }
    }
  }
  .title-h1{
    font-size: 24px;
  }
}
</style>
